<template>
    <div class="app-container">
        <div
        class="community-container">
            <pang-title :text="$router.lang.get('社 群')" eng="Community"/>
            <pang-article-detail
            :title="fullTitle"
            :author="community.article.author_nickname"
            :create_at="community.create_at"
            :content="(community.cover?'<p><img srv=\'' + staticUrl + '/static'+community.cover+'\'/></p>':'')+ community.article.content"/>
            <div class="butt-container" v-if="screenState.user && screenState.user.id == community.article.author_id">
                <pang-butt btype="submit" :text="$router.lang.get('刪除')" @click="deleteCommunity" :style="{marginRight: '0', width: '50px', height: '25px', lineHeight: '25px'}"/>
            </div>
            <pang-comment v-if="community.article.id" :aritcleid="community.article.id"/>
        </div>
        <pang-dialog
            v-if="deleteShowed"
            :title="$router.lang.get('刪除文章')"
            :cancelText="$router.lang.get('取消')"
            :submitText="$router.lang.get('確認')"
            :loading="loading"
            @cancel="cancel" @submit="confirm">
            <div class="dialog-content">
                {{ $router.lang.get('確定要刪除嗎？') }}
            </div>
        </pang-dialog>
    </div>
</template>

<script>
import { useScreenState } from '../../store';
import { PangTitle, PangArticleDetail, PangComment, PangButt, PangDialog } from '../../components'
import enums from '../../utils/enums.js'
import request from '../../api/request'
import message from '../../utils/message'

export default {
    name: 'Detail',
    components: {
        PangTitle,
        PangArticleDetail,
        PangComment,
        PangButt,
        PangDialog,
    },
    data () {
        return {
            loading: false,
            screenState: useScreenState(),
            COMMUNITY_TYPE: enums.COMMUNITY_TYPE,
            STRATEGY_TYPE: enums.STRATEGY_TYPE,
            staticUrl: request.staticUrl,
            deleteShowed: false,
            community:  {
                id: 1,
                article: {
                    content: '',
                    title: ''},
                community_type: 1,
                create_at: '',
            },
            currentPage: 1,
            totalPages: 1,
        };
    },
    methods: {
        deleteCommunity () {
            this.deleteShowed = true
        },
        cancel () {
            this.deleteShowed = false
        },
        confirm () {
            this.loading = true
            let _this = this
            request.delete('/communities/' + this.community.id).then(function (res) {
                _this.loading = false
                if (res.status == 200) {
                    _this.$router.back()
                }
                else if (res.status == 404) {
                    _this.$router.replace('/404')
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
        getCommunity (id) {
            let _this = this
            request.get('/communities/' + id, {}, this).then(function (res) {
                if (res.status == 200) {
                    _this.community = res.data
                }
                else if (res.status == 404) {
                    _this.$router.replace('/404')
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
    },
    computed: {
        fullTitle () {
            let prefix ='[' + this.$router.lang.get('其他') + ']'
            if (this.community.community_type)
                prefix = '[' + enums.COMMUNITY_TYPE[this.community.community_type] + ']'
            else if (this.community.strategy_type)
                prefix = '[' + enums.STRATEGY_TYPE[this.community.strategy_type] + ']'
            return prefix + this.community.article.title
        },
    },
    mounted () {
        this.getCommunity(this.$route.params.id)
    },
}
</script>

<style scoped>

.butt-container {
    max-width: 1000px;
    width: 90vw;
    margin: 40px auto;
}

.dialog-content {
    padding: 30px 0;
    font-size: 20px;
}

</style>
